import { saveAs } from 'file-saver';
import moment from 'moment';
import React, { Component } from 'react';
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import { Redirect } from 'react-router-dom';
import Comm from '../comm/comm';
import Context from '../context/context';
import Translation from '../translation/translation';


export default class ShopReportPrice extends Component {

    constructor(props) {
        super(props);
        if (!Comm.ValidSession())
            return;

        var sid = Context.GetContext().Sid;
        var shops = Comm.CallServerFunction("shop/get_shops", { session: sid }).shops;

        //console.log(shops);
        this.state = {
            sid: sid,
            shops: shops,
            StartDate: moment(),
            EndDate: moment(),
            //perkilo: "1",

        };

        this.Export = this.Export.bind(this);
        this.PrintElem = this.PrintElem.bind(this);
        this.Search = this.Search.bind(this);


    }


    Export(content) {
        var html = "<html><head><meta http-equiv='Content-Type' content='text/html; charset=utf-8' /></head><body>" + content + "</body></html>"
        var file = new Blob([html]);
        saveAs(file, "export.xls");

    }

    PrintElem() {
        var mywindow = window.open('', 'PRINT', 'height=400,width=600');

        mywindow.document.write('<html><head><title>' + document.title + '</title>');

        mywindow.document.write('</head><body >');
        //mywindow.document.write('<h1>' + document.title + '</h1>');
        mywindow.document.write(document.getElementById("tResult").outerHTML);
        mywindow.document.write('</body></html>');

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/
        mywindow.print();
        mywindow.close();

        this.Search();
        return true;
    }

    Search(print = false) {
        var self = this;
        var data = {
            session: this.state.sid,
            from: moment(this.state.StartDate).format("YYYYMMDD"),
            to: moment(this.state.EndDate).format("YYYYMMDD"),
            page: (print ? 0 : this.state.page - 1),
            pagesize: (print ? 1000000000 : this.state.pageSize)
        };
        if (this.state.shopId)
            data.shop = this.state.shopId;

        if (this.state.perkilo)
            data.per_kilo = (this.state.perkilo === "1");

        var result = Comm.CallServerFunction("shop/report_by_price", data);
        console.log("result", result);

        if (print) {
            this.setState({
                rows: result
            }, () => self.PrintElem());
        } else {
            this.setState({
                rows: result
            });
        }


    }




    render() {

        if (!Comm.ValidSession()) {
            Context.Logout();
            return (<Redirect to="/login" push></Redirect>);
        }

        if (Context.RenderNotOK(this.props.history))
            return null;

        var self = this;

        return (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("shopreportprice")}</div>
                <div className="panel-body">
                    <div className="row">
                        <div className="col-md-4">
                            <label for="dpStartDateAnd">{Translation.Trans("shop")}</label>
                            <select className="form-control" value={this.state.shopId} onChange={(e) => this.setState({ shopId: e.target.value })}>
                                <option></option>
                                {
                                    this.state.shops.map(x => <option value={x.id}>{x.name}</option>)
                                }
                            </select>
                        </div>
                        <div className="col-md-4">
                            <label for="dpStartDateAnd">{Translation.Trans("FromDate")}</label>
                            <Datetime
                                inputProps={{ placeholder: 'N/A', readOnly: "true", className: "form-control pointhand" }}
                                dateFormat="DD.MM.YYYY"
                                timeFormat=""
                                onChange={(e) => self.setState({ StartDate: e })}
                                value={this.state.StartDate}
                                closeOnSelect="true"
                            ></Datetime>

                        </div>
                        <div className="col-md-4">
                            <label for="dpEndDateAnd">{Translation.Trans("ToDate")}</label>
                            <Datetime
                                inputProps={{ placeholder: 'N/A', readOnly: "true", className: "form-control pointhand" }}
                                dateFormat="DD.MM.YYYY"
                                timeFormat=""
                                onChange={(e) => self.setState({ EndDate: e })}
                                value={this.state.EndDate}
                                closeOnSelect="true"
                            ></Datetime>

                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label for="dpStartDateAnd">{Translation.Trans("saletype")}</label>
                            <select className="form-control" value={this.state.perkilo} onChange={(e) => this.setState({ perkilo: e.target.value })}>
                                <option></option>
                                <option value="1">{Translation.Trans("perkilo")}</option>
                                <option value="2">{Translation.Trans("perpiece")}</option>
                            </select>
                        </div>
                        <div className="col-md-4">

                        </div>
                        <div className="col-md-4">
                            <button type="button" className="btn btn-default" onClick={() => this.setState({ page: 1 }, () => this.Search())}>{Translation.Trans("report")}</button>
                            <button type="button" className="btn btn-default" onClick={() => this.Search(true)}>{Translation.Trans("print")}</button>
                        </div>
                    </div>
                    {this.state.rows && this.state.rows.data ?
                        <div className="row">
                            <div className="col-md-12">
                                <table className="table table-bordered" id="tResult">
                                    <thead>
                                        <th>{Translation.Trans("shop")}</th>
                                        <th>{Translation.Trans("price")}</th>
                                        <th>{Translation.Trans("quantity")}</th>
                                        <th>{Translation.Trans("total")}</th>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.rows.data.map(dt =>

                                                <tr>
                                                    <td>{dt.shop}</td>
                                                    <td align="right">{dt.price}</td>
                                                    <td align="right">{dt.qty}</td>
                                                    <td align="right">{dt.sum}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>




                            </div>
                        </div>
                        : null}

                </div>


            </div>

        );
    }

}





// WEBPACK FOOTER //
// ./src/pages/shopreportprice.js